<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
            <el-form-item label="类型" prop="orderType">
                <el-select v-model="queryParams.orderType" placeholder="请选择类型">
                    <el-option
                        v-for="item in orderType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="入住人" prop="userName">
                <el-input
                    v-model="queryParams.userName"
                    placeholder="请输入入住人"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input
                    v-model="queryParams.phone"
                    placeholder="请输入手机号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="支付状态" prop="orderStatus">
                <el-select v-model="queryParams.orderStatus" placeholder="请选择支付状态">
                    <el-option
                        v-for="item in orderStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <!--    <el-row :gutter="10" class="mb8">-->
        <!--      <el-col :span="1.5">-->
        <!--        <el-button-->
        <!--          type="primary"-->
        <!--          icon="el-icon-plus"-->
        <!--          size="mini"-->
        <!--          @click="handleAdd"-->
        <!--          v-hasPermi="['fang:orderInfo:add']"-->
        <!--        >新增-->
        <!--        </el-button>-->
        <!--      </el-col>-->
        <!--      <el-col :span="1.5">-->
        <!--        <el-button-->
        <!--          type="success"-->
        <!--          icon="el-icon-edit"-->
        <!--          size="mini"-->
        <!--          :disabled="single"-->
        <!--          @click="handleUpdate"-->
        <!--          v-hasPermi="['fang:orderInfo:edit']"-->
        <!--        >修改-->
        <!--        </el-button>-->
        <!--      </el-col>-->
        <!--      <el-col :span="1.5">-->
        <!--        <el-button-->
        <!--          type="danger"-->
        <!--          icon="el-icon-delete"-->
        <!--          size="mini"-->
        <!--          :disabled="multiple"-->
        <!--          @click="handleDelete"-->
        <!--          v-hasPermi="['fang:orderInfo:remove']"-->
        <!--        >删除-->
        <!--        </el-button>-->
        <!--      </el-col>-->

        <!--      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>-->
        <!--    </el-row>-->

        <el-table v-loading="loading" :data="orderInfoList" @selection-change="handleSelectionChange">
            <!--      <el-table-column type="selection" width="55" align="center"/>-->
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="房型" align="center" prop="xingName"/>
            <el-table-column label="类型" align="center" prop="orderType">
                <template slot-scope="scope">
                    <label style="color: #F56C6C" v-if="scope.row.orderType=='1'">房租</label>
                    <label style="color: #409EFF" v-if="scope.row.orderType=='2'">续租</label>
                    <label style="color: #67C23A" v-if="scope.row.orderType=='3'">水费</label>
                    <label style="color: #E6A23C" v-if="scope.row.orderType=='4'">电费</label>
                </template>
            </el-table-column>
            <el-table-column label="入住人" align="center" prop="userName"/>
            <el-table-column label="手机号" align="center" prop="phone"/>
            <el-table-column label="订单金额(元)" align="center" prop="totalFee">
                <template slot-scope="scope">
                    <label>{{ scope.row.totalFee / 100 }}</label>
                </template>
            </el-table-column>
            <el-table-column label="支付状态" align="center" prop="orderStatus">
                <template slot-scope="scope">
                    <label style="color: #E6A23C" v-if="scope.row.orderStatus=='未支付'">未支付</label>
                    <label style="color: #67C23A" v-if="scope.row.orderStatus=='支付成功'">支付成功</label>
                    <label style="color: #F56C6C" v-if="scope.row.orderStatus=='已取消'">已取消</label>
                </template>
            </el-table-column>
            <el-table-column label="交易时间" align="center" prop="createTime"/>
            <!--      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">-->
            <!--        <template slot-scope="scope">-->
            <!--          <el-button-->
            <!--            size="mini"-->
            <!--            type="text"-->
            <!--            icon="el-icon-edit"-->
            <!--            @click="handleUpdate(scope.row)"-->
            <!--            v-hasPermi="['fang:orderInfo:edit']"-->
            <!--          >修改-->
            <!--          </el-button>-->
            <!--          <el-button-->
            <!--            size="mini"-->
            <!--            type="text"-->
            <!--            icon="el-icon-delete"-->
            <!--            @click="handleDelete(scope.row)"-->
            <!--            v-hasPermi="['fang:orderInfo:remove']"-->
            <!--          >删除-->
            <!--          </el-button>-->
            <!--        </template>-->
            <!--      </el-table-column>-->
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改订单状态对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="订单标题" prop="title">
                    <el-input v-model="form.title" placeholder="请输入订单标题"/>
                </el-form-item>
                <el-form-item label="订单编号" prop="orderNo">
                    <el-input v-model="form.orderNo" placeholder="请输入订单编号"/>
                </el-form-item>
                <el-form-item label="openid" prop="openId">
                    <el-input v-model="form.openId" placeholder="请输入openid"/>
                </el-form-item>
                <el-form-item label="房型id" prop="xingId">
                    <el-input v-model="form.xingId" placeholder="请输入房型id"/>
                </el-form-item>
                <el-form-item label="订单金额" prop="totalFee">
                    <el-input v-model="form.totalFee" placeholder="请输入订单金额"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {listOrderInfo, getOrderInfo, delOrderInfo, addOrderInfo, updateOrderInfo} from "@/api/homestay/api";

export default {
    name: "OrderInfo",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 订单状态表格数据
            orderInfoList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            orderType: [{
                value: '1',
                label: '房租'
            }, {
                value: '2',
                label: '续租'
            }, {
                value: '3',
                label: '水费'
            }, {
                value: '4',
                label: '电费'
            }],
            orderStatus: [{
                value: '未支付',
                label: '未支付'
            }, {
                value: '支付成功',
                label: '支付成功'
            }, {
                value: '已取消',
                label: '已取消'
            }],
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                orderType: null,
                orderNo: null,
                openId: null,
                xingId: null,
                totalFee: null,
                orderStatus: null,
                userName: null,
                phone: null
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                title: [
                    {required: true, message: "订单标题不能为空", trigger: "blur"}
                ],
                orderNo: [
                    {required: true, message: "订单编号不能为空", trigger: "blur"}
                ],
                openId: [
                    {required: true, message: "openid不能为空", trigger: "blur"}
                ],
                xingId: [
                    {required: true, message: "房型id不能为空", trigger: "blur"}
                ],
                totalFee: [
                    {required: true, message: "订单金额不能为空", trigger: "blur"}
                ],
                orderStatus: [
                    {required: true, message: "支付状态 1未支付 2已支付 3已取消不能为空", trigger: "blur"}
                ]
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询订单状态列表 */
        getList() {
            this.loading = true;
            listOrderInfo(this.queryParams).then(response => {
                this.orderInfoList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                title: null,
                orderNo: null,
                openId: null,
                xingId: null,
                totalFee: null,
                orderStatus: 0
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加订单状态";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const id = row.id || this.ids
            getOrderInfo(id).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改订单状态";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateOrderInfo(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addOrderInfo(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || this.ids;
            this.$modal.confirm('是否确认删除订单状态编号为"' + ids + '"的数据项？').then(function () {
                return delOrderInfo(ids);
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            this.download('fang/orderInfo/export', {
                ...this.queryParams
            }, `orderInfo_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
